module.exports = __webpack_public_path__ + "assets/certificate_pdf/p19.fecd7bc0.pdf";